export default __webpack_public_path__ + "static/media/coin.61779932.png";